import PsychologyIcon from '@mui/icons-material/Psychology';
import { useTheme } from '@mui/material';

export const Stress = () => {
  const theme = useTheme();

  return (
    <PsychologyIcon
      fontSize="large"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
